import React from "react";
import {
  FaLightbulb,
  FaShieldAlt,
  FaUsers,
  FaEye,
  FaCheckCircle,
  FaUserTie,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Doug from "../assets/Dong.png";
import Kevin from "../assets/kevin.png";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, type: "spring" as const },
  },
};

const About: React.FC = () => (
  <section className="max-w-5xl mx-auto py-12 px-4">
    {/* Hero Section */}
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeInUp}
      className="bg-gradient-to-r from-blue-100 via-white to-blue-50 rounded-3xl shadow-lg p-8 mb-10 flex flex-col items-center text-center"
    >
      <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-blue-800 drop-shadow">
        About RoomRounds
      </h1>
      {/* <p className="mb-4 text-lg md:text-xl text-gray-700 max-w-2xl">
        RoomRounds was founded by SNF administrators and Silicon Valley technologists to modernize skilled nursing operations. Our mission is to empower facilities with tools that improve compliance, efficiency, and resident care.
      </p> */}
    </motion.div>

    {/* Story, Vision, Values */}
    <div className="grid md:grid-cols-2 gap-8 mb-10">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center"
      >
        <FaLightbulb className="text-blue-800 text-4xl mb-2" />
        <h3 className="text-lg font-bold mb-2 text-blue-800">Our Story</h3>
        {/* <p className="text-justify">
          We didn’t set out to build another EHR.
          <br />
          <br />
          We set out to end the daily chaos that SNF Administrators, Directors
          of Nursing and facilities deal with.
          <br />
          <br />
          Paper checklists that get lost.
          <br />
          Management teams kept in long meetings to review facility issues.
          <br />
          Maintenance issues discovered too late.
          <br />
          Unhappy patients and families.
          <br />
          Surveyors walking the halls while leadership scrambles for proof that
          rounds were actually done.
          <br />
          <br />
          One of our founders watched this exact scenario play out in too many
          facilities—hours wasted, staff burned out, and preventable fines
          stacking up. That moment made it personal.
          <br />
          <br />
          So we built RoomRounds from the ground up as the “first mobile-first,
          non-clinical platform” dedicated exclusively to operational excellence
          in skilled nursing. No HIPAA overhead. Just the tools administrators
          actually need, every shift:
          <br />
          <br />
          • Automated digital room rounds with instant task assignment
          <br />
          • Real-time dashboards that surface issues before they become
          citations
          <br />
          • Proactive maintenance tracking that keeps equipment and environments
          safe
          <br />
          • CMS-ready audit trails that turn survey panic into survey readiness
          <br />
          <br />
          The result? Administrators reclaim 5–30+ hours a week, facilities cut
          fines by up to $10,000 per incident, and staff can finally focus on
          residents instead of paperwork.
          <br />
          <br />
          We’re here to replace clipboards with confidence - because every minute
          saved from meetings is a minute returned to resident care.
        </p> */}
        <p className="text-justify">
          We didn’t set out to build another EHR.
          <br />
          <br />
          We set out to end the daily chaos that SNF Administrators, Directors
          of Nursing and facilities deal with.
          <br />
          <br />
          <ul className="list-disc pl-5">
            <li>Paper checklists that get lost.</li>
            <li>
              Management teams kept in long meetings to review facility issues.
            </li>
            <li>Maintenance issues discovered too late.</li>
            <li>Unhappy patients and families.</li>
            <li>
              Surveyors walking the halls while leadership scrambles for proof
              that rounds were actually done.
            </li>
          </ul>
          <br />
          One of our founders watched this exact scenario play out in too many
          facilities—hours wasted, staff burned out, and preventable fines
          stacking up. That moment made it personal.
          <br />
          <br />
          So we built RoomRounds from the ground up as the “first mobile-first,
          non-clinical platform” dedicated exclusively to operational excellence
          in skilled nursing. No HIPAA overhead. Just the tools administrators
          actually need, every shift:
          <br />
          <br />
          <ul className="list-disc pl-5">
            <li>Automated digital room rounds with instant task assignment.</li>
            <li>
              Real-time dashboards that surface issues before they become
              citations.
            </li>
            <li>
              Proactive maintenance tracking that keeps equipment and
              environments safe.
            </li>
            <li>
              CMS-ready audit trails that turn survey panic into survey
              readiness.
            </li>
          </ul>
          <br />
          The result? Administrators reclaim 5–30+ hours a week, facilities cut
          fines by up to $10,000 per incident, and staff can finally focus on
          residents instead of paperwork.
          <br />
          <br />
          We’re here to replace clipboards with confidence — because every
          minute saved from meetings is a minute returned to resident care.
        </p>
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center"
      >
        <FaEye className="text-blue-800 text-4xl mb-2" />
        <h3 className="text-lg font-bold mb-2 text-blue-800">
          About RoomRounds
        </h3>
        <div className=" space-y-3">
          <p className="text-justify">
            RoomRounds was founded by brothers Doug and Kevin Dillon—two
            lifetimes of real-world experience colliding to solve problems most
            tech companies never see from the inside. <br />
            <br /> Doug Dillon has spent 35+ years running skilled nursing
            facilities rehab departments and therapy teams across California. As
            a physical therapist, former multi-facility operator, instructor,
            and legal consultant, he’s lived every operational headache: lost
            paper rounds, last-minute maintenance scrambles, and the dread of a
            surprise CMS survey. He knows exactly where the cracks are—because
            he’s spent decades patching them with duct tape and hope.
            <br />
            <br /> Kevin Dillon spent 25+ years managing and selling world-class
            technology at Apple, Sun Microsystems, and most recently as the
            global sales leader at Userful—building and scaling platforms used
            by tens of thousands of enterprises. He understands how to take
            complex problems and turn them into software people actually want to
            use.
            <br />
            <br /> Together, they refused to accept that “good enough” was good
            enough for the people caring for our parents and grandparents.
            <br />
            <br /> So they built RoomRounds from the ground up: the first
            mobile-first, non-clinical platform that finally gives
            Administrators the tools they deserve—automated rounds, proactive
            maintenance, real-time dashboards, and bulletproof CMS audit
            trails—all without touching PHI or getting tangled in HIPAA red
            tape.
            <br />
            <br /> The value proposition is simple: gain back 5–30+ hours every
            week, avoid thousands in potential fines, and—most importantly—give
            your staff time to do what they’re trained to do best: focus on
            quality patient care instead of paperwork.
            <br />
            <br /> Two brothers. One mission.
            <br />
            <br />{" "}
            <b> RoomRounds - because senior care deserves better operations.</b>
          </p>
        </div>
      </motion.div>
      {/* <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={fadeInUp} className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center">
        <FaShieldAlt className="text-blue-600 text-4xl mb-2" />
        <h3 className="text-xl font-bold mb-2 text-blue-700">Our Values</h3>
        <ul className="text-gray-700 text-sm space-y-1 text-left mt-2">
          <li className="flex items-center"><FaCheckCircle className="text-green-500 mr-2" />Innovation in healthcare technology</li>
          <li className="flex items-center"><FaCheckCircle className="text-green-500 mr-2" />Commitment to compliance and safety</li>
          <li className="flex items-center"><FaCheckCircle className="text-green-500 mr-2" />Empowering staff and improving workflows</li>
          <li className="flex items-center"><FaCheckCircle className="text-green-500 mr-2" />Transparency and accountability</li>
          <li className="flex items-center"><FaCheckCircle className="text-green-500 mr-2" />Resident-centered care</li>
        </ul>
      </motion.div> */}
    </div>

    {/* Why Choose Us */}
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeInUp}
      className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl shadow p-8 mb-10"
    >
      <h2 className="text-3xl font-bold mb-8 text-center text-blue-700">
        Why Choose Us?
      </h2>
      <ul className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
        <motion.li
          variants={fadeInUp}
          className="flex items-center bg-white rounded-lg shadow p-4"
        >
          <FaUsers className="text-blue-500 text-2xl mr-3" />
          <p> Built by industry experts with decades of combined experience </p>
        </motion.li>
        <motion.li
          variants={fadeInUp}
          className="flex items-center bg-white rounded-lg shadow p-4"
        >
          <FaCheckCircle className="text-green-500 text-2xl mr-3" />
          <p> Trusted by leading SNFs and healthcare organizations </p>
        </motion.li>
        <motion.li
          variants={fadeInUp}
          className="flex items-center bg-white rounded-lg shadow p-4"
        >
          <FaLightbulb className="text-yellow-400 text-2xl mr-3" />
          <p> Continuous product updates and 24/7 support </p>
        </motion.li>
        <motion.li
          variants={fadeInUp}
          className="flex items-center bg-white rounded-lg shadow p-4"
        >
          <FaShieldAlt className="text-blue-600 text-2xl mr-3" />
          <p> Proven results in compliance, efficiency, and satisfaction</p>
        </motion.li>
      </ul>
    </motion.div>

    {/* Founders Section */}
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeInUp}
      className="bg-white rounded-2xl shadow p-8 flex flex-col items-center text-center"
    >
      <h2 className="text-3xl font-bold mb-8 text-center text-blue-700">
        Our Team
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 w-full max-w-5xl mx-auto">
        {[
          {
            name: "Doug Dillon",
            img: Doug,
            link: "https://www.linkedin.com/in/doug-dillon-pt-gtc-csst-fsoae-b43b78ab/",
            desc: "Co-founder & CEO. 35+ years in SNF operations and compliance. Visionary leader driving innovation in healthcare.",
          },
          {
            name: "Kevin Dillon",
            img: Kevin,
            link: "https://www.linkedin.com/in/kevinmdillon/",
            desc: "Co-founder & COO. 20+ years in SaaS and healthcare tech. Expert in building scalable platforms.",
          },
        ].map((founder, idx) => (
          <motion.div
            key={founder.name}
            variants={fadeInUp}
            style={{ cursor: "pointer" }}
            onClick={() => window.open(founder.link, "_blank")}
            className="bg-gradient-to-br from-blue-50 to-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transition"
          >
            <img
              src={founder.img}
              alt={founder.name}
              className="w-24 h-24 rounded-full object-cover border-4 border-blue-200 mb-4 shadow"
            />
            <h2 className="font-bold text-blue-800 text-lg mb-1">
              {founder.name}
            </h2>
            <div className="">
              {" "}
              <p> {founder.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  </section>
);

export default About;
